import { defineNuxtPlugin } from "#app";
import type { AnalyticsOptions } from "~/types/analytics";

export default defineNuxtPlugin(async () => {
  const { appName } = useEnvPaths();
  const { getAnalyticsUrl } = useEnvPaths();
  const appVersion = await useAppVersion();
  const { getSessionId } = useUtils();

  const analyticsOptions: AnalyticsOptions = {
    apiUrl: `${getAnalyticsUrl() as string}`,
    appId: useRuntimeConfig().public.appId,
    userId: getSessionId(),
    tenant: useRuntimeConfig().public.tenant,
    appName: appName() as string,
    useZenAnalytics: true,
    useGtag: useRuntimeConfig().public.analyticsEnabled,
    gtag: {
      enabled: useRuntimeConfig().public.nodeEnv === "production",
      config: {
        id: useRuntimeConfig().public.gaTagIds,
      },
    },
    appReleaseNumber: appVersion.version,
    useageType: "user",
    eventId: "",
    useZenClientHeader: false,
  };

  useAnalytics(analyticsOptions);

  const router = useRouter();
  router.afterEach((to) => {
    nextTick(() => {
      const { sendScreenView } = useAnalytics();
      sendScreenView({ type: "view", target: to.path }, true);
    });
  });
});
